export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-delicious-8305909bd2616d6e968d71344581bb89.svg";